import { Chat } from '../../components/chat/chat';

export const ChatPage = () => {
  return (
    <div className="h-full w-full">
      <Chat />
    </div>
  );
};
